import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBadges from './components/TrustBadges';
import CategoryGrid from './components/CategoryGrid';
import ComparisonTable from './components/ComparisonTable';
import ProductShowcase from './components/ProductShowcase';
import BenefitsSection from './components/BenefitsSection';
import ReviewsSection from './components/ReviewsSection';
import FAQSection from './components/FAQSection';
import SafetySection from './components/SafetySection';
import CTASection from './components/CTASection';
import LatestArticles from './components/LatestArticles';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <article>
          <HeroSection />
          <TrustBadges />
          <CategoryGrid />
          <ComparisonTable />
          <ProductShowcase />
          <BenefitsSection />
          <ReviewsSection />
          <FAQSection />
          <SafetySection />
          <CTASection />
          <LatestArticles />
        </article>
      </main>
      <Footer />
    </div>
  );
}